import IndividualItemPriceSectionProperties from "./IndividualItemPriceSectionProperties";
import React from "react";
import {useStyles} from "./IndividualItemPriceSection.style";
import {Observer} from "mobx-react-lite";
import ShowText from "../../Info/ShowText/ShowText";
import PriceInputShort from "../../Inputs/PriceInputShort/PricetInputShort";
import {CurrencyModule} from "../../../util/Currency";
import TextInputShortType from "../../../ui_components/TextInputShort/TextInputShortType";
import TextInputShort from "../../../ui_components/TextInputShort/TextInputShort";

const IndividualItemPriceSection: React.FC<IndividualItemPriceSectionProperties> = ({
                                                                                        itemPrice,
                                                                                        finalItemPrice,
                                                                                        onFinalItemPriceChange,
                                                                                        weight,
                                                                                        onWeightChange,
                                                                                        group,
                                                                                        onGroupChange,
                                                                                        disable,
                                                                                        fullWidth = false,
                                                                                        className = '',
                                                                                    }) => {

    const classes = useStyles()

    const groupChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = e?.target.value;
        if (value === '') {
            onGroupChange(null);
        }
        const numericValue = parseInt(value, 10);
        if (!isNaN(numericValue)) {
            onGroupChange(numericValue);
        }
    }

    return (
        <Observer>
            {() => (
                <div>
                    <div className={classes.individual_item_price_container}>
                        <ShowText
                            title={"Sugerencia"}
                            text={CurrencyModule.format(itemPrice)}/>
                        <PriceInputShort
                            label={"Precio individual"}
                            value={finalItemPrice}
                            onChange={onFinalItemPriceChange}/>
                        <PriceInputShort
                            label={"Peso"}
                            value={weight}
                            onChange={onWeightChange}/>
                        <TextInputShort
                            type={TextInputShortType.NUMBER}
                            label={"Paquete #"}
                            value={group||1}
                            placeholder={""}
                            onChange={groupChange}
                            className={className}
                            fullWidth={fullWidth}
                        />
                    </div>
                </div>
            )}
        </Observer>
    )
}
export default IndividualItemPriceSection